module.exports = __webpack_public_path__ + "img/backgroundImg.d60c234a.png";